import { RangeFilter } from '@flight-results/entities/request-search.payload';
import { SorterTypes } from '@shared/filters/entities/sorter-options';

export enum FilterTypes {
  Airlines = 'Airlines',
  DepartureTimes = 'DepartureTimes',
  FlightDurations = 'FlightDurations',
  Alliances = 'Alliances',
  BusClass = 'BusClass',
  ArrivalAirports = 'ArrivalAirports',
  DepartureAirports = 'DepartureAirports',
  Stops = 'Stops',
  AirPriceRanges = 'AirPriceRanges',
  MinPrice = 'MinPrice',
  MaxPrice = 'MaxPrice',
  PriceRange = 'PriceRange',
  Results = 'Results',
  AirFilterTabs = 'AirFilterTabs',
  SectorDurations = 'SectorDurations',
  Tags = 'Tags'
}

export enum StopTypes {
  Stops0 = '0',
  Stops1 = '1',
  Stops2 = '2'
}

export enum SectorTypes {
  Sector1 = 'Sector1',
  Sector2 = 'Sector2'
}

export enum AirPriceRangeTypes {
  PriceFrom = 'PriceFrom',
  PriceTo = 'PriceTo'
}

export type FlightFilterApplierValue = string | number | RangeFilter | SorterTypes | string[] | number[];

export type FilterApplier = Readonly<{
  type: FilterTypes,
  value: FlightFilterApplierValue,
  removable?: boolean;
  sector?: number | null;
  orderDesc?: boolean | null;
  widget?: Readonly<{ index?: number; }>;
}>;

export type AirportFilter = Readonly<{
  SectorNumber: number,
  Airports: string[]
}>;
